/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getSuggestedUsersSkeleton.defs.js'
export * as $defs from './getSuggestedUsersSkeleton.defs.js'
